import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class GlobalToolsService {
  useTool(tool: string, ...args: any[]): Promise<any> {
    return Promise.resolve({ success: true, message: `Tool ${tool} used with args: ${args}` });
  }

  getAvailibleTools(): string {
    return 'Implementar availible tools. ';
  }
}
